<template>
  <div class="content importList import-box import_new_wrap">
    <div class="import-title">
      <div class="back" @click="$router.back()">返回</div>
      <span>查询导入进度</span>
    </div>
    <div class="button-area mt0">
      <div>
        <el-upload
          class="upload-demo"
          action="#"
          multiple
          :limit="1"
          accept=".xlsx,.xsl,.xls,.xlsm"
          :before-upload="beforeUpload"
          :on-exceed="handleExceed"
          :http-request="changeFile"
          :file-list="fileList"
          :show-file-list="false"
        >
          <el-button size="mini" type="importNew">批量导入</el-button>
        </el-upload>
        <el-button size="mini" type="borderGreen" @click="refreshData">
          刷新结果
        </el-button>
        <span style="color: #999; margin-left: 10px">
          请及时刷新查看最终结果
        </span>
      </div>
      <div class="mr16">
        <el-button size="mini" type="deleteNew" @click="delFile(1)">
          批量删除
        </el-button>
      </div>
    </div>
    <div class="back-color-fff content-main-box">
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        border
        tooltip-effect="light"
        v-loading="tableLoading"
        stripe
        :height="tableHeight"
      >
        <el-table-column
          type="selection"
          width="40"
          header-align="center"
          align="center"
          :selectable="selected"
        ></el-table-column>
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="fileName"
          label="文件名称"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="350"
        >
          <template slot-scope="scope">{{
            scope.row.fileName || "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="importState"
          label="状态"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="85"
        >
          <template slot-scope="scope">
            <span :class="getStateClass(scope.row.importState)">
              {{ scope.row.importState | importStateNew }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="importMessage"
          label="导入结果"
          header-align="center"
          align="left"
          show-overflow-tooltip
          min-width="250"
        >
          <template slot-scope="scope">
            {{ scope.row.importMessage || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="导入时间"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="140"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime | getTime }}
          </template>
        </el-table-column>
        <el-table-column
          prop="bank"
          width="230px"
          label="操作"
          header-align="center"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <a
              :class="
                scope.row.importState == 1
                  ? 'fontC-bbb cursor-sty'
                  : 'txt-color'
              "
              @click="
                downloadFile(scope.row.filePath, 1, scope.row.importState)
              "
            >
              下载文件
            </a>
            <a
              class="txt-color"
              @click="downloadFile(scope.row.errorFilePath, 2)"
              v-if="scope.row.importState == -1"
            >
              ｜下载异常数据
            </a>
            <a
              class="txt-color"
              @click="delFile(2, scope.row.guid)"
              v-if="scope.row.importState !== 1"
            >
              ｜删除
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
  </div>
</template>

<script>
import importCommon from "@/uilt/importCommon";

export default {
  data() {
    return {
      exportUrl: `/${serverConfig.msCommonImportDataService}/import-data/import-common`,
      tableLoading: false,
      tableHeight: window.innerHeight - 278,
      tableData: [],
      multipleSelection: [],
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        importType: "0042", //导入类型
      },
      fileList: [],
    };
  },
  methods: {
    //批量导入
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split(".");
      if (arr[1] !== "xls" && arr[1] !== "xlsx" && arr[1] !== "xlsm") {
        this.$message.error("上传文件只能是 excel/xls 格式!");
        return false;
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    async changeFile(file, fileList) {
      this.fileList = [];
      this.tableLoading = true;
      const userInfo = JSON.parse(localStorage.userInfo);
      const extendFields = JSON.stringify({
        serviceTenantGuid: localStorage.guid,
      });
      const formData = new FormData();
      formData.append("file", file.file); //传文件
      formData.append('importType', this.page.importType);
      formData.append('extendFields', extendFields);
      formData.append('tenantGuid', localStorage.guid);
      formData.append('staffGuid', userInfo.staffGuid);
      const { data } = await this.api.postFile(
        this.exportUrl,
        formData
      );
      this.tableLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return false;
      }
      this.$message.success(messageConfig.UPLOAD_SUCCESS);
      this.page.pageIndex = 1;
      this.getData();
    },
    refreshData() {
      this.page.pageIndex = 1;
      this.getData();
    },
    async getData() {
      const self = this;
      const query = JSON.parse(JSON.stringify(self.page));
      const userInfo = JSON.parse(localStorage.userInfo);
      query.staffGuid = userInfo.staffGuid;
      self.tableLoading = true;
      const { data } = await self.api.postJson(
        `/${serverConfig.msCommonImportDataService}/import-data/list`,
        query
      );
      self.tableLoading = false;

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      self.tableData = data.data.records || [];
      self.page.totalPage = data.data.totalPages;
      self.page.totalRows = data.data.totalRows;
    },
    handleSelectionChange(val) {
      this.multipleSelection = [];
      if (val && val.length > 0) {
        val.forEach((i) => {
          this.multipleSelection.push(i.guid);
        });
      }
    },
    //禁用导入中状态选项
    selected(row) {
      return importCommon.getDelSelected(row.importState);
    },
    //获取状态样式
    getStateClass(state) {
      return importCommon.getImportStateClass(state);
    },
    //下载文件/模板
    downloadFile(url, type, state) {
      if (type == 1 && state == 1) {
        this.$message.error(messageConfig.IMPORT_HANDLE);
        return;
      }
      if (!url) {
        this.$message.error(messageConfig.IMPORT_FILE_BROKEN);
        return;
      }
      // type为1下载文件 2为异常数据下载文件 不为1下载模板
      window.open(url);
    },
    //删除文件
    async delFile(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (!self.multipleSelection.length) {
          self.$message.error(messageConfig.DELETE_SELECT);
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }

      let res = null;
      try {
        res = await this.$confirm(messageConfig.DELETE_AFTER, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch (error) {
        res = "cancel";
        if (error === "cancel") {
          this.$message({
            type: "info",
            message: messageConfig.CANCEL_TIP,
          });
        }
      }
      if (res !== "confirm") {
        return;
      }
      self.tableLoading = true;
      const { data } = await self.api.postJson(
        `/${serverConfig.msCommonImportDataService}/import-data/delete`,
        self.multipleSelection
      );

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.tableLoading = false;
        self.$message.error(data.msg);
        return;
      }
      self.tableLoading = false;
      self.multipleSelection = [];
      self.$message.success(messageConfig.DELETE_SUCCESS);
      self.page.pageIndex = 1;
      self.getData();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.getData();
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped lang="less">
.content-main-box {
  height: calc(100vh - 60px - 35px - 66px - 54px - 58px);
  overflow-y: auto;
}

.import-title {
  background: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;

  .back {
    background: #ffffff;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
  }
}
.upload-demo {
  display: inline-block;
  margin: 0 5px;
}
</style>
